import { PageTitle } from "../../components";
import { Tabs } from "antd";

function Privacy() {
  const englishContent = (
    <div
      style={{
        width: "80%",
        textAlign: "left",
        marginLeft: "10%",
        marginTop: "2%",
        fontSize: "14px",
        lineHeight: "1.6",
      }}
    >
      <h2>Privacy Policy</h2>
      <p>
        <strong>Effective Date:</strong> {new Date().toLocaleDateString()}
      </p>
      <p>
        <strong>Last Updated:</strong> {new Date().toLocaleDateString()}
      </p>

      <h3>1. Introduction</h3>
      <p>
        Digital Archery LLC ("we," "our," or "us") operates the Mongolian
        Archery application (the "Service"). This Privacy Policy explains how we
        collect, use, disclose, and safeguard your information when you use our
        mobile application and related services.
      </p>

      <h3>2. Information We Collect</h3>
      <h4>2.1 Personal Information</h4>
      <p>We collect the following personal information:</p>
      <ul>
        <li>Full name (first and last name)</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Government identification number (SSN)</li>
        <li>Date of birth</li>
        <li>Gender</li>
        <li>Team affiliation</li>
        <li>Archery rankings and scores</li>
        <li>Competition participation records</li>
        <li>Profile photos (optional)</li>
        <li>Payment status for competitions</li>
      </ul>

      <h4>2.2 Automatically Collected Information</h4>
      <ul>
        <li>Device information and operating system</li>
        <li>App usage analytics</li>
        <li>Performance metrics</li>
        <li>Log data and error reports</li>
      </ul>

      <h3>3. How We Use Your Information</h3>
      <p>We use collected information for:</p>
      <ul>
        <li>Managing archery competitions and tournaments</li>
        <li>Calculating rankings and scores</li>
        <li>Facilitating team management</li>
        <li>Processing competition registrations</li>
        <li>Communicating about competitions and results</li>
        <li>Improving app functionality and user experience</li>
        <li>Ensuring fair play and competition integrity</li>
      </ul>

      <h3>4. Information Sharing and Disclosure</h3>
      <h4>4.1 Third-Party Services</h4>
      <p>
        We use the following third-party services that may collect information:
      </p>
      <ul>
        <li>
          <strong>Firebase (Google):</strong> For authentication, database, and
          analytics
        </li>
        <li>
          <strong>Google Analytics:</strong> For app usage analytics
        </li>
      </ul>

      <h4>4.2 Data Sharing</h4>
      <p>We may share your information:</p>
      <ul>
        <li>With competition organizers for tournament management</li>
        <li>With team leaders for team management purposes</li>
        <li>When required by law or legal proceedings</li>
        <li>To protect our rights, property, or safety</li>
      </ul>

      <h3>5. Data Security</h3>
      <p>
        We implement appropriate security measures to protect your personal
        information against unauthorized access, alteration, disclosure, or
        destruction. Data is encrypted in transit and at rest using
        industry-standard security protocols.
      </p>

      <h3>6. Data Retention</h3>
      <p>
        We retain your personal information for as long as necessary to provide
        our services and comply with legal obligations. Competition data may be
        retained for historical record-keeping purposes.
      </p>

      <h3>7. Your Rights</h3>
      <p>You have the right to:</p>
      <ul>
        <li>Access your personal information</li>
        <li>Correct inaccurate data</li>
        <li>Request deletion of your data</li>
        <li>Withdraw consent for data processing</li>
        <li>Data portability</li>
      </ul>

      <h3>8. Children's Privacy</h3>
      <p>
        Our service may be used by minors participating in archery competitions.
        We require parental consent for users under 18 years of age.
      </p>

      <h3>9. International Data Transfers</h3>
      <p>
        Your information may be transferred to and processed in countries other
        than Mongolia, including the United States, where our service providers
        are located.
      </p>

      <h3>10. Changes to This Privacy Policy</h3>
      <p>
        We may update this Privacy Policy from time to time. We will notify you
        of any changes by posting the new Privacy Policy on this page and
        updating the "Last Updated" date.
      </p>

      <h3>11. Contact Us</h3>
      <p>
        If you have any questions about this Privacy Policy, please contact us:
      </p>
      <ul>
        <li>
          <strong>Company:</strong> Digital Archery LLC
        </li>
        <li>
          <strong>Email:</strong> info@mongolian-archery.mn
        </li>
        <li>
          <strong>Address:</strong> Mongolia
        </li>
      </ul>

      <h3>12. Governing Law</h3>
      <p>
        This Privacy Policy is governed by the laws of Mongolia and applicable
        international privacy regulations.
      </p>
    </div>
  );

  const mongolianContent = (
    <div
      style={{
        width: "80%",
        textAlign: "left",
        marginLeft: "10%",
        marginTop: "2%",
        fontSize: "14px",
        lineHeight: "1.6",
      }}
    >
      <h2>Нууцлалын Бодлого</h2>
      <p>
        <strong>Хүчин төгөлдөр болсон огноо:</strong>{" "}
        {new Date().toLocaleDateString()}
      </p>
      <p>
        <strong>Сүүлд шинэчилсэн:</strong> {new Date().toLocaleDateString()}
      </p>

      <h3>1. Танилцуулга</h3>
      <p>
        "Дижитал Арчери" ХХК нь Монголын Харваа аппликешныг үйл ажиллагаа
        явуулдаг. Энэхүү нууцлалын бодлого нь бидний таны мэдээллийг хэрхэн
        цуглуулах, ашиглах, хуваалцах, хамгаалах талаар тайлбарладаг.
      </p>

      <h3>2. Бидний цуглуулдаг мэдээлэл</h3>
      <h4>2.1 Хувийн мэдээлэл</h4>
      <p>Бид дараах хувийн мэдээллийг цуглуулдаг:</p>
      <ul>
        <li>Бүтэн нэр (өвөг, нэр)</li>
        <li>Цахим шуудангийн хаяг</li>
        <li>Утасны дугаар</li>
        <li>Регистрийн дугаар</li>
        <li>Төрсөн огноо</li>
        <li>Хүйс</li>
        <li>Багийн харъяалал</li>
        <li>Харваачдын зэрэглэл, оноо</li>
        <li>Тэмцээний оролцооны бүртгэл</li>
        <li>Профайлын зураг (сайн дураараа)</li>
        <li>Тэмцээний төлбөрийн төлөв</li>
      </ul>

      <h4>2.2 Автомат цуглуулагддаг мэдээлэл</h4>
      <ul>
        <li>Төхөөрөмжийн мэдээлэл, үйлдлийн систем</li>
        <li>Аппликешн ашиглалтын шинжилгээ</li>
        <li>Гүйцэтгэлийн хэмжигдэхүүн</li>
        <li>Лог өгөгдөл, алдааны тайлан</li>
      </ul>

      <h3>3. Мэдээллийг хэрхэн ашигладаг</h3>
      <p>Цуглуулсан мэдээллийг дараах зорилгоор ашигладаг:</p>
      <ul>
        <li>Харваачдын тэмцээн, тэмцээг удирдах</li>
        <li>Зэрэглэл, оноо тооцоолох</li>
        <li>Багийн удирдлагыг дэмжих</li>
        <li>Тэмцээний бүртгэлийг боловсруулах</li>
        <li>Тэмцээн, үр дүнгийн талаар мэдээлэх</li>
        <li>Аппликешны функц, хэрэглэгчийн туршлагыг сайжруулах</li>
        <li>Шударга тэмцээн, тэмцээний бүрэн бүтэн байдлыг хангах</li>
      </ul>

      <h3>4. Мэдээлэл хуваалцах</h3>
      <h4>4.1 Гуравдагч талын үйлчилгээ</h4>
      <p>Бид мэдээлэл цуглуулах дараах гуравдагч талын үйлчилгээг ашигладаг:</p>
      <ul>
        <li>
          <strong>Firebase (Google):</strong> Нэвтрэх, өгөгдлийн сан,
          шинжилгээнд
        </li>
        <li>
          <strong>Google Analytics:</strong> Аппликешн ашиглалтын шинжилгээнд
        </li>
      </ul>

      <h4>4.2 Өгөгдөл хуваалцах</h4>
      <p>Бид таны мэдээллийг дараах тохиолдолд хуваалцаж болно:</p>
      <ul>
        <li>Тэмцээний зохион байгуулагчидтай тэмцээн удирдахад</li>
        <li>Багийн ахлагчидтай багийн удирдлагын зорилгоор</li>
        <li>Хууль эрх зүйн шаардлага, шүүхийн шийдвэрээр</li>
        <li>Бидний эрх, өмч, аюулгүй байдлыг хамгаалахад</li>
      </ul>

      <h3>5. Өгөгдлийн аюулгүй байдал</h3>
      <p>
        Бид таны хувийн мэдээллийг зөвшөөрөлгүй хандалт, өөрчлөлт, задруулалт,
        устгалаас хамгаалахын тулд зохих аюулгүй байдлын арга хэмжээг авч
        хэрэгжүүлдэг.
      </p>

      <h3>6. Өгөгдөл хадгалах хугацаа</h3>
      <p>
        Бид таны хувийн мэдээллийг үйлчилгээ үзүүлэх, хуулийн үүргээ биелүүлэхэд
        шаардлагатай хугацаанд хадгалдаг.
      </p>

      <h3>7. Таны эрх</h3>
      <p>Та дараах эрхтэй:</p>
      <ul>
        <li>Хувийн мэдээллээ үзэх</li>
        <li>Буруу өгөгдлийг засах</li>
        <li>Өгөгдлөө устгахыг хүсэх</li>
        <li>Өгөгдөл боловсруулахаас татгалзах</li>
        <li>Өгөгдөл зөөх</li>
      </ul>

      <h3>8. Хүүхдийн нууцлал</h3>
      <p>
        Манай үйлчилгээг харваачдын тэмцээнд оролцож буй насанд хүрээгүй
        хүүхдүүд ашиглаж болно. 18 нас хүрээгүй хэрэглэгчдээс эцэг эхийн
        зөвшөөрөл шаарддаг.
      </p>

      <h3>9. Олон улсын өгөгдөл шилжүүлэх</h3>
      <p>
        Таны мэдээлэл Монголоос бусад улс орнуудад, тухайлбал манай үйлчилгээ
        үзүүлэгчид байрладаг АНУ-д шилжүүлэгдэж болно.
      </p>

      <h3>10. Нууцлалын бодлогын өөрчлөлт</h3>
      <p>
        Бид энэхүү нууцлалын бодлогыг үе үе шинэчилж болно. Ямар нэгэн
        өөрчлөлтийг энэ хуудсанд нийтэлж, "Сүүлд шинэчилсэн" огноог шинэчлэх
        замаар мэдэгдэнэ.
      </p>

      <h3>11. Холбоо барих</h3>
      <p>
        Энэхүү нууцлалын бодлогын талаар асуулт байвал бидэнтэй холбогдоно уу:
      </p>
      <ul>
        <li>
          <strong>Компани:</strong> Дижитал Арчери ХХК
        </li>
        <li>
          <strong>Цахим шуудан:</strong> info@mongolian-archery.mn
        </li>
        <li>
          <strong>Хаяг:</strong> Монгол улс
        </li>
      </ul>

      <h3>12. Хэрэглэх хууль</h3>
      <p>
        Энэхүү нууцлалын бодлого нь Монгол улсын хууль тогтоомж болон олон улсын
        нууцлалын зохицуулалтаар удирддаг.
      </p>
    </div>
  );

  const items = [
    {
      key: "1",
      label: "English",
      children: englishContent,
    },
    {
      key: "2",
      label: "Монгол",
      children: mongolianContent,
    },
  ];

  return (
    <>
      <PageTitle
        title="Privacy Policy | Нууцлалын Бодлого"
        description="Privacy Policy and Terms of Service"
      />
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <Tabs defaultActiveKey="1" items={items} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Privacy;
